<template>
  <b-form @submit="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <b>{{ plano.nome }}</b>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos">Salvar</b-button>

            <router-link
              :to="$routeBack('planos_list')"
              class="btn btn-outline-muted mr-2"
              >Voltar para Listagem</router-link
            >
          </div>
        </div>
      </template>

      <b-tabs pills card vertical class="edit-menu-sidebar">
        <b-tab active>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.dados_basicos"
            />
            Dados Básicos
          </template>
          <DadosBasicos ref="dados_basicos" />
        </b-tab>
        <b-tab>
          <template #title>
            <font-awesome-icon
              icon="exclamation-triangle"
              class="text-warning"
              v-if="!validations.tipos_instituicoes"
            />
            Tipos de Instituições
          </template>
          <TiposInstituicoes ref="tipos_instituicoes" />
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import safeArray from "lodash/toArray";
import cloneDeep from "lodash/cloneDeep";

import DadosBasicos from "./Form/DadosBasicos.vue";
import TiposInstituicoes from "@/modules/planos/Components/Form/TiposInstituicoes.vue";

export default {
  components: { DadosBasicos, TiposInstituicoes },
  data: () => ({
    validations: {
      dados_basicos: true,
      tipos_instituicoes: true,
    },
  }),
  computed: {
    ...mapState("planos", ["plano"]),
  },
  methods: {
    ...mapActions("planos", ["ActionSave"]),
    async onSubmit(event) {
      event.preventDefault();

      if (!this.isValid()) {
        this.$notifications.addNotification({
          message: "Os dados do formulário são inválidos",
          type: "danger",
        });
      } else {
        try {
          const plano = cloneDeep(this.plano);

          plano.tipos_instituicoes = safeArray(plano.tipos_instituicoes).map(
            (tipo) => (typeof tipo === "number" ? tipo : tipo.id)
          );

          plano.plano_consultor = plano.plano_consultor ? 1 : 0

          await this.ActionSave(plano);
          this.$emit("saved", this.plano.id);

          this.$notifications.addNotification({
            message: "Registro salvo com sucesso",
            type: "success",
          });

          this.$refs.tipos_instituicoes.reset();
        } catch (error) {
          let error_message = "Erro ao salvar";
          this.$notifications.addNotification({
            message: error_message,
            icon: "exclamation-triangle",
            type: "danger",
          });
        }
      }
    },
    isValid() {
      this.validations.dados_basicos = this.$refs.dados_basicos.isValid();
      this.validations.tipos_instituicoes =
        this.$refs.tipos_instituicoes.isValid();

      return Object.values(this.validations).every(Boolean);
    },
  },
  async created() {},
};
</script>

<style></style>
